const topics = [
  { name: '狂飙大结局', count: '128万讨论', icon: 'ri-fire-line' },
  { name: '流浪地球3', count: '96万讨论', icon: 'ri-rocket-2-line' },
  { name: '暑期档电影', count: '85万讨论', icon: 'ri-sun-line' },
  { name: '国产悬疑崛起', count: '72万讨论', icon: 'ri-search-eye-line' },
  { name: '经典港片回顾', count: '63万讨论', icon: 'ri-vidicon-line' },
  { name: '综艺名场面', count: '58万讨论', icon: 'ri-emotion-laugh-line' },
  { name: '动漫新番推荐', count: '51万讨论', icon: 'ri-palette-line' },
  { name: '高分韩剧合集', count: '47万讨论', icon: 'ri-heart-line' },
  { name: '纪录片精选', count: '39万讨论', icon: 'ri-earth-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              热门话题
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门话题
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              全网影视爱好者正在热议的话题
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <div
                key={topic.name}
                className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full cursor-pointer hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200"
              >
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100">
                  <i className={`${topic.icon} text-accent-600 text-xs`}></i>
                </div>
                <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">{topic.name}</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}